// extracted by mini-css-extract-plugin
module.exports = {"button":"_0fce717cdb--button--vG76v"};